import { LayerCollection, MapProperties } from '@datum-map';
import { Card } from './Card';
import { BrowserHistoryToCardLink } from './BrowserHistoryToCard';
import { Map } from './Map';
import { CardToBrowserHistoryLink } from './CardToBrowserHistory';

export class LinkController {
  map: Map;

  private _browserHistoryToCard: BrowserHistoryToCardLink;
  private _cardToBrowserHistory: CardToBrowserHistoryLink;

  readonly card: Card;

  constructor(prop: MapProperties, collection: LayerCollection) {
    this.map = new Map(prop, collection);

    this.card = new Card();

    this._browserHistoryToCard = new BrowserHistoryToCardLink(this.card);
    this._cardToBrowserHistory = new CardToBrowserHistoryLink(this.card);
  }

  bind = () => {
    this.unbind();

    this._cardToBrowserHistory.bind();
    this._browserHistoryToCard.bind();

    return this.unbind;
  };

  unbind = () => {
    this._cardToBrowserHistory.unbind();
    this._browserHistoryToCard.unbind();
  };
}
